import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const consumTransAdapter = createEntityAdapter({})

const initialState = consumTransAdapter.getInitialState()

export const consumTransApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getConsumTransactions: builder.query({
            query: (filter) => ({
                url: '/consumtrans',
                params: filter,
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            
            transformResponse: responseData => {
                const loadedTransactions= responseData.map(transaction => {
                    transaction.id = transaction._id
                    return transaction
                });
                return consumTransAdapter.setAll(initialState, loadedTransactions)
            },
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'CONSUMTRANS', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'Consumtrans', id }))
                    ]
                } else return [{ type: 'CONSUMTRANS', id: 'LIST' }]
            }
        }),
        addNewConsumTransaction: builder.mutation({
            query: initialTransactionData => ({
                url: '/consumtrans',
                method: 'POST',
                body: {
                    ...initialTransactionData,
                }
            }),
            invalidatesTags: [
                { type: 'CONSUMTRANS', id: "LIST" }
            ]
        }),       
        updateConsumTransaction: builder.mutation({
            query: initialTransactionData => ({
                url: '/consumtrans',
                method: 'PUT',
                body: {
                    ...initialTransactionData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'CONSUMTRANS', id: arg.id }
            ]
        }),       
        deleteConsumTransaction: builder.mutation({
            query: ({ id }) => ({
                url: `/consumtrans`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'CONSUMTRANS', id: arg.id }
            ]
        }),
        getConsumTransactionsFiltered: builder.query({
            query: ({ page, limit, filters = {} }) => {
                // Convert arrays to comma-separated strings and filter out empty values
                const processedFilters = {};
                
                Object.keys(filters).forEach(key => {
                    const value = filters[key];
                    
                    // Skip null, undefined, empty strings, and empty arrays
                    if (value === null || value === undefined || value === '') {
                        return;
                    }
                    
                    if (Array.isArray(value)) {
                        // Only add if array has items
                        if (value.length > 0) {
                            processedFilters[key] = value.join(',');
                        }
                    } else {
                        processedFilters[key] = value;
                    }
                });
                
                console.log('Consumable Transactions API Query Params:', { ...processedFilters, page, limit });
                
                return {
                    url: "/consumtrans/filtered",
                    params: { ...processedFilters, page, limit },
                    validateStatus: (response) => response.status === 200,
                };
            },
            transformResponse: (responseData) => {
                const transformedData = {
                    transactions: responseData.transactions?.map((transaction) => ({
                        ...transaction,
                        id: transaction._id,
                    })) || [],
                    totalFilteredTransactions: responseData.totalFilteredTransactions || 0,
                    totalPages: responseData.totalPages || 1,
                };
                return transformedData;
            },
            providesTags: (result) =>
                result?.transactions
                    ? [
                        { type: "CONSUMTRANS", id: "LIST" },
                        ...result.transactions.map((transaction) => ({
                            type: "CONSUMTRANS",
                            id: transaction.id,
                        })),
                    ]
                    : [{ type: "CONSUMTRANS", id: "LIST" }],
        }),       
    }),
})

export const {
    useGetConsumTransactionsQuery,
    useGetConsumTransactionsFilteredQuery,
    useLazyGetConsumTransactionsFilteredQuery,
    useAddNewConsumTransactionMutation,
    useUpdateConsumTransactionMutation,
    useDeleteConsumTransactionMutation
} = consumTransApiSlice